import React from "react";
import { IPSAgent, getAgentLink } from "../../../models/peer-support";
import { UIActions } from "../Actions";

export type AgentActionsProps = {
	agent: IPSAgent;
	onEditAgent: (data, id: string) => Promise<any>;
	onDeleteAgent: (data) => Promise<any>;
	omitLink?: boolean;
};

export const AgentActions: React.FC<AgentActionsProps> = (props: AgentActionsProps) => {
	const agent: IPSAgent = props.agent;
	return (
		<UIActions
			itemName={`${agent.first_name} ${agent.last_name}`}
			data={agent}
			uid={agent.uid}
			onDelete={(data) => props.onDeleteAgent(data)}
			editEntityProps={{
				mode: "Edit",
				entity: "member",
				data: agent,
				onSubmit: (data) => props.onEditAgent(data, agent.id),
			}}
			detailUrl={props.omitLink ? undefined : getAgentLink(agent)}
		/>
	);
};
